import { Routes } from '@angular/router';
import { AgreementsComponent } from './app/components/agreements/agreements.component';
import { LotDetailsComponent } from './app/components/bids-and-offers/lot-details/lot-details.component';
import { NewLotComponent } from './app/components/bids-and-offers/lot-new/new-lot.component';
import { LotsComponent } from './app/components/bids-and-offers/lots.component';
import { FaqPageComponent } from './app/components/faq-page/faq-page.component';
import { HomePageComponent } from './app/components/home-page/home-page.component';
import { JohnstonsDailyPageComponent } from './app/components/johnstons-daily-page/johnstons-daily-page.component';
import { ForgotPasswordComponent } from './app/components/login/forgot-password/forgot-password.component';
import { LoginComponent } from './app/components/login/login.component';
import { NewPasswordComponent } from './app/components/login/new-password/new-password.component';
import { RegisterComponent } from './app/components/login/register/register.component';
import { VerificationCodeComponent } from './app/components/login/verification-code/verification-code.component';
import { ContractDetailsComponent } from './app/components/my-profile/contracts/contract-details/contract-details.component';
import { ContractsComponent } from './app/components/my-profile/contracts/contracts.component';
import { MyBidsOffersComponent } from './app/components/my-profile/my-bids-offers/my-bids-offers.component';
import { MyProfileComponent } from './app/components/my-profile/my-profile.component';
import { CounterComponent } from './app/components/negotiations/counter/counter.component';
import { NegotiationsDetailsComponent } from './app/components/negotiations/negotiations-details/negotiations-details.component';
import { NegotiationsComponent } from './app/components/negotiations/negotiations.component';
import { NewNegotiationComponent } from './app/components/negotiations/new-negotiation/new-negotiation.component';
import { NotFoundComponent } from './app/components/not-found/not-found.component';
import { TradesComponent } from './app/components/trades/trades.component';
import { accessAuthGuard } from './app/guards/access-auth.guard';
import { authGuard } from './app/guards/auth.guard';
import { blockViewerGuard } from './app/guards/block-viewer.guard';
import { privacyTermsGuard } from './app/guards/privacy-terms.guard';
import { NewBidOfferComponent } from './app/components/bids-and-offers/new-bid-offer/new-bid-offer.component';

export const routes: Routes = [
  {
    path: 'app',
    canActivate: [authGuard, privacyTermsGuard],
    children: [
      {
        path: '',
        redirectTo: 'lots',
        pathMatch: 'full',
      },
      {
        path: 'lots',
        component: LotsComponent,
      },
      {
        path: 'lots/new/bid',
        canActivate: [blockViewerGuard],

        component: NewBidOfferComponent,
      },
      {
        path: 'lots/new/offer',
        canActivate: [blockViewerGuard],

        component: NewBidOfferComponent,
      },
      {
        path: 'lots/repost/offer',
        canActivate: [blockViewerGuard],

        component: NewBidOfferComponent,
      },
      {
        path: 'lots/repost/bid',
        canActivate: [blockViewerGuard],

        component: NewBidOfferComponent,
      },
      {
        path: 'lots/repost/:id',
        canActivate: [blockViewerGuard],

        component: NewBidOfferComponent,
      },
      {
        path: 'lots/:id',
        canActivate: [blockViewerGuard],
        component: LotDetailsComponent,
      },
      {
        path: 'lots/:id/new-negotiation',
        canActivate: [blockViewerGuard],

        component: NewNegotiationComponent,
      },
      {
        path: 'trades',
        component: TradesComponent,
      },
      {
        path: 'negotiations',
        canActivate: [blockViewerGuard],

        component: NegotiationsComponent,
      },
      {
        path: 'negotiations/:id',
        canActivate: [blockViewerGuard],

        component: NegotiationsDetailsComponent,
      },
      {
        path: 'negotiations/:id/counter',
        canActivate: [blockViewerGuard],

        component: CounterComponent,
      },

      // TODO: Dead code — either revive chat or delete (recoverable via git history).
      // HIDE UNTIL FINISHED
      // { path: 'chat-list', component: ChatListComponent, canActivate: [authGuard] },
      // { path: 'chat', component: ChatComponent, canActivate: [authGuard] },

      {
        path: 'contracts',
        component: ContractsComponent,
      },
      {
        path: 'contracts/:id',
        canActivate: [blockViewerGuard],

        component: ContractDetailsComponent,
      },
      {
        path: 'my-profile',
        component: MyProfileComponent,
      },
      {
        path: 'my-profile/my-bids-and-offers',
        component: MyBidsOffersComponent,
      },
      {
        path: 'faqs',
        component: FaqPageComponent,
      },
      {
        path: 'faqs/:group',
        component: FaqPageComponent,
      },
      {
        path: 'faqs/:group/:article',
        component: FaqPageComponent,
      },
      { path: 'johnstons-daily', component: JohnstonsDailyPageComponent },
    ],
  },
  {
    path: 'agreements',
    component: AgreementsComponent,
    children: [
      { path: 'terms-of-use', component: AgreementsComponent },
      {
        path: 'privacy-policy',
        component: AgreementsComponent,
      },
    ],
  },
  {
    path: 'faqs',
    canActivate: [accessAuthGuard],
    children: [
      { path: '', component: FaqPageComponent },
      {
        path: ':group',
        component: FaqPageComponent,
      },
      {
        path: ':group/:article',
        component: FaqPageComponent,
      },
    ],
  },

  { path: 'home', component: HomePageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verification-code', component: VerificationCodeComponent },
  { path: 'new-password', component: NewPasswordComponent },
  { path: '', redirectTo: 'app/lots', pathMatch: 'full' },
  { path: 'not-found', component: NotFoundComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '/not-found', pathMatch: 'full' },
];
